<template>
  <div class="formWrapper mb-5">
    <div class="formWrapper__header">
      <Icon icon="delivery" class="formWrapper__header__icon" />
      <h3>Punkty dostaw</h3>
    </div>
    <delivery-points-number-form class="formWrapper__inner" />
  </div>
</template>

<script>
import Icon from '@/components/Icon.vue';
import DeliveryPointsNumberForm from './DeliveryPointsNumberForm.vue';

export default {
  name: 'DeliveryPointsNumberFormSection',
  components: {
    Icon,
    DeliveryPointsNumberForm,
  },
};
</script>
